<script>
import DibbleJS from "../../dibble";
import DibbleApi from "../../api";
import vueCustomScrollbar from 'vue-custom-scrollbar'
import Datepicker from "vuejs-datepicker";

export default {
    name: "UpComingEvents",
    props: {
        boatType: Number,
        showInfoSportBoat: Boolean,
        showButtonScanQR: Boolean,
    },
    components: { vueCustomScrollbar, Datepicker },
    data() {
        return {
            router: this.$router,
            orderStatusColor: {
                3: '#DC3444',
                9: '#6ac847'
            },
            dibbleJs: DibbleJS,
            scrollbarSettings: {
                maxScrollbarLength: 620,
                wheelPropagation: false
            },
            filterDate: this.$cookies.get('_dateRental') ? this.$moment(this.$cookies.get('_dateRental')) : this.$moment(new Date()),
            filterDateStr: this.$cookies.get('_dateRental') ? this.$moment(this.$cookies.get('_dateRental')).format('MM.DD.YYYY') : this.$moment(new Date()).format('MM.DD.YYYY'),
            datePicker: null,
            boatTypes: [],
            orders: [],
            availableBoats: []
        }
    },
    created() {
        this.getRentalBoatTypes()
    },
    methods: {
        getRentalBoatTypes() {
            const params = {
                request: DibbleApi.api.getRentalBoatTypes,
            };
            this.dibbleJs.callApiRequest(params, (response) => {
                if (DibbleApi.isResponseSuccess(response)) {
                    this.boatTypes = response.boat_types
                    this.loadOrderHistories()
                }
            });
        },
        loadOrderHistories(showLoader = false) {
            if (showLoader) {
                this.dibbleJs.showLoader()
            }

            const params = {
                request: DibbleApi.api.getRentalBoatOrdersHistory,
                /*filter_boat_type: this.boatType,*/
                page: -1,
                filter_from_date: this.filterDate.format('YYYY-MM-DD 00:00:00'),
                filter_to_date: this.filterDate.format('YYYY-MM-DD 23:59:59'),
                filter_boat_serial: this.selectBoat,
                sort_by: 8,
                sort_ascending: true,
            };
            this.dibbleJs.callApiRequest(params, this._onSuccess);
        },
        _onSuccess(response) {
            this.dibbleJs.hideLoader();
            if (DibbleApi.isResponseSuccess(response)) {
                // Reset all orders state
                this.orders = []
                const { orders, availability } = response;
                this.availableBoats = availability
                if (orders.length) {
                    for (const i in orders) {
                        const boatType = this.boatTypes.find(type => type.boat_type === orders[i].boat_type)
                        if (boatType) {
                            const orderItemIdx = this.orders.findIndex(order => order.boat_type === boatType.boat_type)
                            if (orderItemIdx !== -1) {
                                this.orders[orderItemIdx].orders.push(orders[i])
                            } else {
                                const itemContent = {
                                    boat_type: boatType.boat_type,
                                    boat_type_name: boatType.name,
                                    orders: []
                                }
                                itemContent.orders.push(orders[i])
                                this.orders.push(itemContent)
                            }
                        }
                    }
                }
            }
        },
        decreaseDate() {
            this.filterDate = this.filterDate.subtract(1, 'days')
            this.filterDateStr = this.filterDate.format('MM/DD/YYYY')
            this.$cookies.set('_dateRental', this.filterDate, '365d');
            this.loadOrderHistories(true)
        },
        increaseDate() {
            this.filterDate = this.filterDate.add(1, 'days')
            this.filterDateStr = this.filterDate.format('MM/DD/YYYY')
            this.$cookies.set('_dateRental', this.filterDate, '365d');
            this.loadOrderHistories(true)
        },
        customFormatter(date) {
            return this.$moment(date).format("MM/DD/YYYY");
        },
        setToToday() {
            this.filterDateStr = this.$moment(new Date()).format('MM.DD.YYYY');
            this.filterDate = this.$moment(new Date());
            this.$cookies.set('_dateRental', new Date(), '365d');
        }
    },
    watch: {
        datePicker(value) {
            if (value) {
                this.$cookies.set('_dateRental', value, '365d');
                this.filterDateStr = this.$moment(value).format("MM/DD/YYYY");
                this.filterDate = this.$moment(value);
            }
        },
        filterDateStr() {
            this.loadOrderHistories(true)
        }
    }
}
</script>
<template src="./template/up-coming-events/index.html"></template>
<style lang="scss" scoped>
.order-item-row {
    cursor: pointer
}

.order-item-row:hover {
    background: #cfd8dc;
}
</style>
<style lang="scss">
.date-upcomming-event {
    border: none;
    width: 100%;
    background: transparent;
    position: absolute !important;
    top: 1px;
    left: 0;
}

.date-upcomming-event input {
    max-width: 100% !important;
    width: 100%;
    opacity: 0;
}

.order-status {
    margin-left: 10px;
    color: #c5c5c5;
    font-size: 18px;
}


.rental-info {
    background: #E8EFF1;
    border-radius: 40px;
    display: flex;
    flex-direction: column;

    p {
        font-family: 'Open Sans';
        font-style: normal;
    }

    .first-session {
        height: auto;
        padding: 20px;

    }

    .rental-header {
        width: 100%;
        display: flex;
        flex-direction: column;

        .rental-title {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .title {
                font-size: 22px;
                color: #1C5169;
                font-weight: 600;
            }
        }

        .date-rental {
            font-weight: 600;
            font-size: 40px;
            color: #555E67;
            cursor: pointer;
        }
    }

    .set-today {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .time {
            font-size: 30px;
            font-weight: 300;
            color: #555E67;
        }

        .btn-set-today {
            font-weight: 600;
            font-size: 20px;
            color: #2C94AB;
            cursor: pointer;
        }
    }

    .line-through {
        height: 1.5px;
        background: #DEE6EA;
        width: calc(100% + 40px);
        margin-left: -20px;
    }

    .boat-availability {
        .title-availability {
            font-weight: 700;
            font-size: 16px;
            color: #1C5169;
        }

        .available-boat-item {
            font-weight: 600;
            font-size: 14px;
            line-height: 18px;
            letter-spacing: 0.01em;
            color: #7C7C7A;
        }
    }

    .second-session {
        flex: 1;

        .sport-boat {
            background: #C2D8DD;
            padding: 20px;
            border-radius: 40px;
            width: 100%;
        }

        .header-boat {
            p {
                font-weight: 700;
                font-size: 16px;
                color: #1C5169;
            }
        }

        .boat-info {
            .header-boat {
                width: 100%;
                display: flex;
                justify-content: space-between;

                .name {
                    font-weight: 700;
                    font-size: 14px;
                    letter-spacing: 0.01em;
                    color: #1C5169;
                }

                .status {
                    font-weight: 600;
                    font-size: 14px;
                    letter-spacing: 0.01em;
                }
            }

            .text-info-boat {
                font-weight: 700;
                font-size: 14px;
                color: #555E67;
            }
        }
    }

    .button-scan-qr {
        display: flex;
        justify-content: flex-end;
        margin: 20px 10px;
        border-top: 1.5px solid #DEE6EA;
        flex: 1;
        flex-direction: column;
        align-items: center;

        button {
            background: #1C5169;
            box-shadow: 0px 13px 30px -12px rgba(0, 0, 0, 0.25);
            border-radius: 100px;
            border: none;
            margin-top: 20px;
            width: max-content;
        }

        p {
            font-weight: 600;
            font-size: 20px;
            color: #FFFFFF;
            text-align: center;
            padding: 10px 20px;
        }
    }
}

.height-full {
    height: 85vh;
    max-height: 85vh;
}

@media only screen and (max-width: 1250px) {
    .button-scan-qr {
        p {
            font-size: 16px !important;
            padding: 10px 10px;
        }
    }
}
</style>
